import type { VersionDiff } from "@procurement-agents/scope-api";
import { wordDiff } from "../diff";

/** Section-level diff between two template versions: added, removed, changed fields (word diff for text), order. */
export function VersionDiffView({ diff }: { diff: VersionDiff }) {
  const empty = !diff.added.length && !diff.removed.length && !diff.changed.length && !diff.reordered && !Object.keys(diff.meta ?? {}).length;
  if (empty) return <p className="muted">No differences.</p>;
  const text = (v: unknown) => (v == null ? "" : Array.isArray(v) ? v.join(", ") : String(v));
  return (
    <div className="version-diff">
      {Object.entries(diff.meta ?? {}).map(([k, v]) => <p key={k} className="small"><strong>{k}</strong>: <del>{text(v.before)}</del> → <ins>{text(v.after)}</ins></p>)}
      {diff.added.map((s) => <p key={s.section_id} className="small"><ins>Added</ins> {s.title}</p>)}
      {diff.removed.map((s) => <p key={s.section_id} className="small"><del>Removed</del> {s.title}</p>)}
      {diff.reordered && <p className="small muted">Sections were reordered.</p>}
      {diff.changed.map((c) => (
        <details key={c.section_id} open className="diff-section">
          <summary><strong>{c.title}</strong> <span className="muted small">{c.fields.join(", ")}</span></summary>
          {c.fields.map((f) => (
            <div key={f} className="diff-field">
              <span className="field-label">{f}</span>
              <pre className="diff">{wordDiff(text(c.before[f]), text(c.after[f])).map((o, i) => o.type === "same" ? <span key={i}>{o.text}</span> : o.type === "add" ? <ins key={i}>{o.text}</ins> : <del key={i}>{o.text}</del>)}</pre>
            </div>
          ))}
        </details>
      ))}
    </div>
  );
}
